export const proxyConfig = {
  appName: "ViVa AI故事汇",
  baseUrl: "https://www.vivaapi.cn",
  priceCoefficient: 0.7,
  wechatSupportId: "VIVA-API",
  tutorialLink: "https://my.feishu.cn/wiki/EPP6wHZEVi1Wi4kZac5cGWDTnx3",
  recruitmentLink: "https://my.feishu.cn/wiki/O6Q9wrxxci898Wkj6ndcFnlknJd",
};
